export default __webpack_public_path__ + "static/media/gallery_10.dba9e271.jpg";